import(/* webpackMode: "eager" */ "/var/www/snapbox-landingpage/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/var/www/snapbox-landingpage/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/var/www/snapbox-landingpage/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/var/www/snapbox-landingpage/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/var/www/snapbox-landingpage/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/var/www/snapbox-landingpage/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Noto_Sans_KR\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"100\",\"300\",\"400\",\"500\",\"700\",\"800\",\"900\"],\"display\":\"swap\",\"variable\":\"--font-noto-sans-kr\",\"fallback\":[\"system-ui\",\"arial\"],\"adjustFontFallback\":true}],\"variableName\":\"notoSansKr\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/snapbox-landingpage/src/components/layouts/MainLayout/index.tsx");
